import api, {
  QueryV1PostStripeClient,
  QueryV1PostStripeClientParams,
} from '@/modules/api';

import {
  StripeV2PaymentRequest,
  StripeV2PaymentResponse,
  StripeV2PricesRequest,
  StripeV2PricesResponse,
} from './';

class StripeService {
  getV2Prices(params: StripeV2PricesRequest) {
    return api.post<StripeV2PricesResponse, StripeV2PricesRequest>(
      'base',
      '/stripe_v2/prices',
      params,
    );
  }

  createV2Payment(params: StripeV2PaymentRequest) {
    return api.post<StripeV2PaymentResponse, StripeV2PaymentRequest>(
      'base',
      '/stripe_v2/payment',
      params,
      { withCredentials: true },
    );
  }

  createClient(params: QueryV1PostStripeClientParams) {
    return api.post<QueryV1PostStripeClient, QueryV1PostStripeClientParams>(
      'v1',
      '/stripe/client',
      params,
      { withCredentials: true },
    );
  }

  updateClient(params: Pick<QueryV1PostStripeClientParams, 'email'>) {
    return api.post<QueryV1PostStripeClient, QueryV1PostStripeClientParams>(
      'v1',
      '/stripe/client/update',
      params,
    );
  }
}

export const stripeService = new StripeService();
